import { AuthShell } from "../components/AuthShell"
import { ForgotPasswordForm } from "../components/ForgotPasswordForm"
import { useAuthedRedirect } from "../useAuthedRedirect"
import { useDocumentTitle } from "../useDocumentTitle"

/**
 * Forgot-password page. Ported from business-v2 `(auth)/forgot-password/page.tsx`.
 */
export function ForgotPasswordPage() {
  useDocumentTitle("Forgot password · Badminton Warriors")
  useAuthedRedirect()
  return (
    <AuthShell title="Reset your password">
      <ForgotPasswordForm />
    </AuthShell>
  )
}
